import { ITelemetryItem } from '@microsoft/applicationinsights-web';

// Scripts de terceiros carregados na página. Os erros deles não são da aplicação
// e, desde que as promises rejeitadas passaram a ser registradas, o widget do
// Freshstatus sozinho gerava ~5 mil exceções por dia, escondendo as reais.
const THIRD_PARTY_SCRIPT_HOSTS = ['cdn.freshstatus.io', 'googletagmanager.com'];

// Tags do GTM que usam jQuery ($) sem carregá-lo. Em alguns navegadores a pilha
// vem sem o arquivo do GTM, então a mensagem também identifica o erro.
const THIRD_PARTY_MESSAGES = ['$ is not defined', "Can't find variable: $"];

interface IStackFrame {
  fileName?: string;
  assembly?: string;
}

interface IExceptionDetails {
  message?: string;
  stack?: string;
  parsedStack?: IStackFrame[];
}

const comesFromThirdParty = (exception: IExceptionDetails): boolean => {
  const message = (exception.message ?? '').trim();
  if (THIRD_PARTY_MESSAGES.some((thirdPartyMessage) => message.endsWith(thirdPartyMessage))) {
    return true;
  }

  const sources = [
    exception.stack ?? '',
    ...(exception.parsedStack ?? []).flatMap((frame) => [frame.fileName ?? '', frame.assembly ?? '']),
  ];

  return sources.some((source) => THIRD_PARTY_SCRIPT_HOSTS.some((host) => source.includes(host)));
};

/**
 * Telemetry initializer do Application Insights: devolve `false` para descartar
 * exceções lançadas por scripts de terceiros antes do envio.
 */
export const isThirdPartyException = (item: ITelemetryItem): boolean => {
  if (item.baseType !== 'ExceptionData') {
    return false;
  }

  const exceptions: IExceptionDetails[] = item.baseData?.exceptions ?? [];

  return exceptions.some(comesFromThirdParty);
};
